/**
 * Sticky Hero — hides once scrolled past so it
 * doesn't appear behind the sticky footer.
 * Works with any .sticky-hero element.
 *
 * Also un-pins the hero when it's taller than the viewport: a sticky element
 * bigger than the window pins at top:0 straight away, so its lower part (CTAs,
 * press strip) can never be scrolled into view. Measured live, because the
 * threshold depends on the hero's own content height, not a fixed breakpoint.
 */
export default function setupFixedHero() {
  const hero = document.querySelector('.sticky-hero')
  if (!hero) return

  // The bottom of the hero is decoration (padding + the arc edge into the next
  // section), not content — losing it costs nothing, so allow this much overflow
  // before giving up the sticky treatment. Sized so the press-logo strip, the
  // lowest real content, still just clears the fold: it ends ~120px above the
  // hero's bottom edge, so at 100px of overflow it stays on screen.
  const OVERFLOW_TOLERANCE = 100

  function syncPinned() {
    // Measure the natural height with the class off, so a hero that shrinks
    // back under the viewport can re-pin rather than latching un-pinned.
    hero.classList.remove('sticky-hero--unpinned')
    if (hero.offsetHeight > window.innerHeight + OVERFLOW_TOLERANCE) {
      hero.classList.add('sticky-hero--unpinned')
    }
  }

  function onScroll() {
    const rect = hero.getBoundingClientRect()
    hero.style.visibility = rect.bottom <= 0 ? 'hidden' : ''
  }

  syncPinned()
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', syncPinned)

  if ('ResizeObserver' in window) {
    // Catches late content growth (fonts, images, carousel slides) without
    // waiting on a resize event. Toggling the class doesn't change the hero's
    // own box height, so this can't feed back into itself.
    new ResizeObserver(syncPinned).observe(hero)
  }
}
